import { API, Logger, graphqlOperation } from 'aws-amplify';

import { manageExecution } from '../../../graphql/mutations';

const logger = new Logger('useExecutionManager');

export function closeExecution(executionId) {
  const variables = {
    command: 'Close',
    args: JSON.stringify({
      ExecutionId: executionId
    })
  };
  return _manageExecution(variables);
}

export function getExecutionInputLog(executionId, inputUri) {
  const variables = {
    command: 'InputLog',
    args: JSON.stringify({
      ExecutionId: executionId,
      InputUri: inputUri
    })
  };
  return _manageExecution(variables);
}

export function startExecution(workloadId, args) {
  const select_args=Object.assign({},args,{ "WorkloadId": workloadId });
  const variables = {
    command: 'Select',
    args: JSON.stringify(select_args)
  };
  return _manageExecution(variables);
}

export function stopExecution(executionId) {
  const variables = {
    command: 'Stop',
    args: JSON.stringify({
      ExecutionId: executionId
    })
  };
  return _manageExecution(variables);
}

async function _manageExecution(variables) {

  try {
    logger.debug('manageExecution MUTATION: ',manageExecution);
    logger.debug('manageExecution VARIABLES: ',variables);
    const res=await API.graphql(graphqlOperation(manageExecution, variables));
    logger.info('execution manager success: ',res);
    return {
      succeeded: true,
      data: JSON.parse(res.data.manageExecution),
      error: null,
    };
  } catch (err) {
    logger.error('execution manager failure: ', err);
    return {
      succeeded: false,
      data: null,
      error: err,
    };
  }
}
